import { Text } from '@factorialco/deprecated-design-system'
import { SessionFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { useSessionsData } from 'modules/trainings/hooks/Sessions/useSessionsData'

interface Props {
  sessions: SessionFragment[]
}

export const EndDate = ({ sessions }: Props) => {
  const { getEndDate } = useSessionsData({ sessions })

  if (sessions.length === 0) return <Text size="300">-</Text>

  const endDate = getEndDate()

  if (!endDate)
    return <Text size="300">{i18n.t('trainings.training_catalog.datatable.self_paced')}</Text>

  return <Text size="300">{dateToString(moment(endDate), 'ui_short_with_time')}</Text>
}
